import { useTranslation } from "react-i18next";
import { Icon } from "../icons";

interface LegalScreenProps {
  isDesktop: boolean;
  title: string;
  lastUpdated: string;
  onBack: () => void;
  children: React.ReactNode;
}

export function LegalScreen({
  isDesktop,
  title,
  lastUpdated,
  onBack,
  children,
}: LegalScreenProps) {
  const { t } = useTranslation();
  const wrap: React.CSSProperties = isDesktop
    ? { width: "100%", maxWidth: 680, margin: "0 auto", padding: "0 0 60px" }
    : { flex: 1, overflow: "auto", padding: "24px 24px 60px" };

  return (
    <div style={wrap}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          marginBottom: 18,
        }}
      >
        <button
          onClick={onBack}
          aria-label={t("common.back")}
          style={{
            width: 36,
            height: 36,
            borderRadius: 999,
            background: "var(--surface)",
            border: "1px solid var(--line)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {Icon.back()}
        </button>
        <div style={{ fontSize: 15, fontWeight: 600 }}>{title}</div>
      </div>

      <div
        style={{
          fontSize: 11,
          fontWeight: 500,
          color: "var(--muted)",
          letterSpacing: ".08em",
          textTransform: "uppercase",
          marginBottom: 18,
        }}
      >
        {t("legal.lastUpdatedPrefix")} · {lastUpdated}
      </div>

      <div
        style={{
          background: "var(--surface)",
          border: "1px solid var(--line)",
          borderRadius: 14,
          padding: "22px 22px 6px",
        }}
      >
        {children}
      </div>
    </div>
  );
}

export function Section({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div style={{ marginBottom: 22 }}>
      <h2
        style={{
          fontSize: 14,
          fontWeight: 600,
          margin: "0 0 10px",
          color: "var(--ink)",
          letterSpacing: "-.005em",
        }}
      >
        {title}
      </h2>
      {children}
    </div>
  );
}

export function Paragraph({ children }: { children: React.ReactNode }) {
  return (
    <p
      style={{
        fontSize: 14,
        lineHeight: 1.7,
        color: "var(--ink-2)",
        margin: "0 0 12px",
      }}
    >
      {children}
    </p>
  );
}
